












import { defineComponent } from '@vue/composition-api';
import { ParagraphSize } from '@getaccept/lib-ui';

export default defineComponent({
  props: {
    thumbUrl: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      ParagraphSize,
    };
  },
});
